import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectRank = (state : GlobalState) => state.onna.rank;

export const onnaRankSelector = createSelector(
    [selectRank],
    (data ) => data
)
